<template>
<div>
  <div class="payt-carousel-container">
    <div
      v-if="videoCode"
      class="payt-carousel-item">
      <div class="ratio ratio-16x9">
        <div
          id="vitrine-desktop-video-player"
          :data-video-id="videoCode" />
      </div>
    </div>
    <div
      v-for="(foto, i) in fotosParsed"
      :key="i"
      class="payt-carousel-item">
      <img
        :src="foto"
        class="w-100"
        alt="Imagem de vitrine">
    </div>
  </div>
  <div
    v-if="nItens > 0"
    class="payt-carousel-preview-container">
    <div
      v-if="nItens > 5"
      class="payt-carousel-control-left"
      @click="previusPreviewPage">
      <i class="fa-solid fa-angle-left" />
    </div>
    <div class="payt-carousel-preview-icons-container">
      <div
        v-if="videoCode"
        class="payt-carousel-preview-item"
        data-index="0">
        <img
          :src="'https://img.youtube.com/vi/' + videoCode + '/hqdefault.jpg'"
          alt="Preview de vídeo da vitrine">
      </div>
      <div
        v-for="(foto, i) in fotosParsed"
        :key="i"
        class="payt-carousel-preview-item"
        :data-index=" i + (videoCode ? 1 : 0)">
        <img
          :src="foto"
          alt="Preview de imagem da vitrine">
      </div>
    </div>
    <div
      v-if="nItens > 5"
      class="payt-carousel-control-right"
      @click="nextPreviewPage">
      <i class="fa-solid fa-angle-right" />
    </div>
  </div>
</div>
</template>

<script>
export default {
    props: {
        fotos: {
            type: String,
            default: () => '[]',
            required: true,
        },
        videoCode: {
            type: String,
            default: () => '',
            required: true,
        },
    },
    data() {
        return {
            index: 0,
            previewPage: 0,
            container: null,
            previewItensContainer: null,
            isScrolling: false,
            cycleIntervalId: null,
            scrollTargetLeft: 0,
            pauseAutomaticPreviewScroll: false,
        };
    },
    computed: {
        fotosParsed() {
            return JSON.parse(this.$props.fotos);
        },
        nItens() {
            const nFotos = this.fotosParsed.length;
            if(this.$props.videoCode) {
                return nFotos + 1;
            }
            return nFotos;
        }
    },
    watch: {
        index() {
            this.updatePreviewIconsActive();
            this.automaticUpdatePreviewPage();
        }
    },
    mounted() {
        this.setupContainers();
        this.setupPreviewIconsClick();
        this.updatePreviewIconsActive();
        this.cycle();
    },
    methods: {
        next() {
            this.goTo(this.index + 1);
        },
        previus() {
            this.goTo(this.index - 1);
        },
        cycle() {
            if(this.cycleIntervalId) {
                return;
            }
            this.cycleIntervalId = setInterval(this.next, 8000);
        },
        pause() {
            if(!this.cycleIntervalId) {
                return;
            }
            clearInterval(this.cycleIntervalId);
            this.cycleIntervalId = null;
        },
        goTo(index) {
            if(this.isScrolling || !this.container) {
                return false;
            }
            if(index == this.index) {
                return true;
            }
            if(index < 0 || index >= this.nItens) {
                index = 0;
            }

            this.isScrolling = true;
            this.scrollTargetLeft = this.getScrollLeftForIndex(index);
            this.container.scroll(this.scrollTargetLeft, 0);
            this.index = index;
            return true;
        },
        getCarouselItems() {
            if(!this.container) {
                return [];
            }
            const items = [];
            for (const child of this.container.children) {
                if(child.classList.contains('payt-carousel-item')) {
                    items.push(child);
                }
            }
            return items;
        },
        getCarouselItemWidth() {
            if(!this.container) {
                return 0;
            }
            for (const child of this.container.children) {
                if(child.classList.contains('payt-carousel-item')) {
                    return child.getBoundingClientRect().width;
                }
            }
            return 0;
        },
        getScrollLeftForIndex(index) {
            if(!this.container) {
                return 0;
            }
            const maxScroll = Math.max(this.container.scrollWidth - this.container.clientWidth, 0);

            return Math.min(index * this.getCarouselItemWidth(), maxScroll);
        },
        onContainerScroll() {
            if(Math.abs(this.container.scrollLeft - this.scrollTargetLeft) <= 2) {
                this.isScrolling = false;
            }
        },
        onContainerClicked() {
            this.pause();
        },
        previusPreviewPage() {
            if(this.previewPage <= 0) {
                return;
            }
            this.pauseAutomaticPreviewScroll = true;
            this.pause();
            this.goToPreviewPage(this.previewPage - 1);
        },
        nextPreviewPage() {
            if(this.previewPage >= this.getPreviewNPages()) {
                return;
            }
            this.pauseAutomaticPreviewScroll = true;
            this.pause();
            this.goToPreviewPage(this.previewPage + 1);
        },
        automaticUpdatePreviewPage() {
            if(this.pauseAutomaticPreviewScroll) {
                return;
            }
            const pageOfCurrentIndex = Math.floor(this.index / 5);
            this.goToPreviewPage(pageOfCurrentIndex);
        },
        goToPreviewPage(page) {
            if(page < 0 || page >= this.getPreviewNPages()) {
                page = 0;
            }
            const previewWith = this.previewItensContainer.offsetWidth;
            this.previewItensContainer.scroll(page * previewWith, 0);
            this.previewPage = page;
        },
        getPreviewNPages() {
            const nItens = this.getPreviewItems().length;

            return Math.ceil(nItens / 5);
        },
        getPreviewItems() {
            if(!this.previewItensContainer) {
                return [];
            }

            const items = [];
            for (const child of this.previewItensContainer.children) {
                if(child.classList.contains('payt-carousel-preview-item')) {
                    items.push(child);
                }
            }
            return items;
        },
        setupContainers() {
            for (const child of this.$el.children) {
                if(child.classList.contains('payt-carousel-container')) {
                    this.container = child;
                    this.container.addEventListener('scroll', this.onContainerScroll);
                    this.container.addEventListener('click', this.onContainerClicked);
                    break;
                }
            }
            let previewContainer = null;
            for (const child of this.$el.children) {
                if(child.classList.contains('payt-carousel-preview-container')) {
                    previewContainer = child;
                    break;
                }
            }
            if(!previewContainer) {
                return;
            }

            for (const child of previewContainer.children) {
                if(child.classList.contains('payt-carousel-preview-icons-container')) {
                    this.previewItensContainer = child;
                    break;
                }
            }
        },
        updatePreviewIconsActive() {
            const items = this.getPreviewItems();
            items.forEach(item => {
                const index = item.getAttribute('data-index');
                if(index == this.index) {
                    item.classList.add('active');
                } else {
                    item.classList.remove('active');
                }
            });
        },
        setupPreviewIconsClick() {
            const items = this.getPreviewItems();
            items.forEach(item => {
                const index = item.getAttribute('data-index');
                item.addEventListener('click', () => {
                    if(this.isScrolling) {
                        return;
                    }
                    this.pauseAutomaticPreviewScroll = true;
                    this.pause();
                    this.goTo(index);
                });
            });
        }
    }
};

</script>
<style scoped>
.payt-carousel-container {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: flex-start;
  overflow: hidden;
  scroll-behavior: smooth;
}

.payt-carousel-item {
  width: 100%;
  flex-grow: 0;
  flex-shrink: 0;
  border-radius: 6px;
  overflow: hidden;
}


.payt-carousel-preview-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 30px;
}

.payt-carousel-control-left,.payt-carousel-control-right {
  width: 5%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  align-items: flex-start;
  font-size: 20px;
}
.payt-carousel-control-right {
  align-items: flex-end;
}


.payt-carousel-preview-icons-container {
  width: 90%;
  overflow: hidden;
  display: flex;
  scroll-behavior: smooth;
}
.payt-carousel-preview-item {
  width: 20%;
  padding-left: 1.5%;
  padding-right: 1.5%;
  flex-shrink: 0;
  overflow: hidden;
  cursor: pointer;
  margin: auto;
}
.payt-carousel-preview-item>img {
  width: 100%;
  aspect-ratio: 16/9;
  border-radius: 6px;
}
.payt-carousel-preview-item.active>img {
  border: 2px solid #E88A1D;
}
</style>
